export default "__VITE_ASSET__B2x6abic__"